import { CssBaseline, ThemeProvider } from "@mui/material";
import { LoadScript } from "@react-google-maps/api";
import { useRoutes } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThemeSettings } from "./theme/Theme";
import RTL from "./layouts/full/shared/customizer/RTL";
import ScrollToTop from "./components/shared/ScrollToTop";
import Router from "./routes/Router";
// import mqtt, { subscribe } from "precompiled-mqtt";
// import { useEffect } from "react";

function App() {
  const routing = useRoutes(Router);
  const theme = ThemeSettings();
  const customizer = useSelector((state) => state.customizer);

  // mosquitto test broker
  // const URL = "mqtt://dl.iotasonl.com:20012";

  // Local broker
  // const URL = "ws://192.168.43.xx:1234";

  // const client = mqtt.connect(URL);

  // const topic = "gps/864180065797776/data";
  // client.on("connect", () => {
  //   console.log("CONNECTED to broker");
  //   client.subscribe(topic, (err) => {
  //     if (err) {
  //       console.log("Error subscribing to gps topic:", err);
  //     } else {
  //       console.log(`Subscribed to ${topic} topic`);
  //     }
  //   });
  // });

  // get message from broker and log it to console
  // const onMessage = (callBack) => {
  //   client.on("message", (topic, message, packet) => {
  //     callBack(JSON.parse(new TextDecoder("utf-8").decode(message)));
  //   });
  // };

  // useEffect(() => {
  //   onMessage((message) => {
  //     console.log("Message received from broker:", message);
  //   });
  // }, []);

  return (
    <ThemeProvider theme={theme}>
      <RTL direction={customizer.activeDir}>
        <CssBaseline />
        <ScrollToTop>
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
            libraries={["places", "drawing", "geometry"]}
          >
            {routing}
          </LoadScript>
        </ScrollToTop>
      </RTL>
    </ThemeProvider>
  );
}

export default App;
